import React from "react";
import { NavLink, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { NotificationManager } from "react-notifications";
import { Loader } from "../../components/loader";
import { fetchBreedQuizFeatures, createBreedQuizFeatures, getQuizFeaturesViaBreed, getAvailableQuizBreeds } from "../../actions/quiz";
import Select from "react-select";
import { formValueSelector } from "redux-form";

const $ = window.$;

class AddQuizMapping extends React.Component {
    constructor(props) {
        super(props);
        this.state = {         
            loading : false,         
            breedId: null,       
            breedQuizFeatures:[],
            selectedBreedAttributeList:[],
            defaultBreedArributes : { friendly : false, protective: false, independent: false, energetic : false, very_energetic : false, low_energy : false, moderate_energy : false, extra_small : false, small : false,
               medium : false, large: false, x_large : false, hypoallergenic : false, minimal_shedding : false, moderate_shedding : false, high_shedding : false, kid_friendly : false, easy_to_train : false
            }         
         };      
}

  closeModal = () => {
   $("#add_quiz_mapping").modal("hide");
  }

  submitBreedQuizFeatures(e) {  
    e.preventDefault();
    const breedId = this.state.breedId;
    let defaultAttributes = this.state.defaultBreedArributes; 
    if(breedId){
      defaultAttributes.BreedId = breedId;
      this.setState({ loading : true });
      this.props.createBreedQuizFeatures(defaultAttributes);  
    }else{
      NotificationManager.warning('Please select the breed first');
    }

  }   


  checkboxHandler =(e,attributeObj,index) =>{
    let breedQuizFeatures = [...this.state.breedQuizFeatures]; 
    const breedId = this.state.breedId; 
    let defaultAttributes = this.state.defaultBreedArributes;
    if( breedId){
      if(e.target.checked){
        defaultAttributes[attributeObj.title] = true;
      }else{   
        defaultAttributes[attributeObj.title] = false;
     
      }
      breedQuizFeatures[index].value = e.target.checked; 
      this.setState({ defaultBreedArributes : defaultAttributes });
    }else{
      NotificationManager.warning("Please select the breed first");
    }   
  }

  changeBreed = selected => {
    if (!selected || selected.value) {
      this.setState({ breedId: selected.value, selectedBreedAttributeList : [] });

    }
  };

  reset = () => {
    let defaultData = { friendly : false, protective: false, independent: false, energetic : false, low_energy : false, moderate_energy : false, extra_small : false, small : false,
       medium : false, large: false, x_large : false, hypoallergenic : false, moderate_shedding : false, high_shedding : false, kid_friendly : false, easy_to_train : false
    };     
    this.setState({defaultBreedArributes : defaultData });    
  };

  componentDidMount = () => {
    this.props.fetchBreedQuizFeatures();
    this.props.getAvailableQuizBreeds();

  };

  componentWillReceiveProps = nextProps => { 

    if ( nextProps.availableBreed && this.props.availableBreed !== nextProps.availableBreed ) {
      let options = [{ label: "SELECT BREED", value: null }];
      nextProps.availableBreed.map(p => {
        options.push({ label: p.breed_type, value: p.id });
      });
      this.setState({ breeds: options });  
    }

    if (nextProps.breedQuizFeatures  && this.props.breedQuizFeatures !== nextProps.breedQuizFeatures  ) {  
       const allAttributeList = nextProps.breedQuizFeatures;
       let allQuiizAttributes = [];    
       for(let item of allAttributeList ){
        allQuiizAttributes.push({ BreedQuizFeatureId : item.id, description : item.description, title : item.title, value : false });
       }   
       this.setState({ breedQuizFeatures : allQuiizAttributes });  
    } 
    
    if(nextProps.createdBreedQuizFeatures !== this.props.createdBreedQuizFeatures){
      this.setState({ loading : false, breedId : null, breedQuizFeatures : [] });
      NotificationManager.success('Quiz feature created successfully');
      $('#add_quiz_mapping').modal('hide');
      this.props.getAvailableQuizBreeds();
      this.props.fetchBreedQuizFeatures();
      this.reset();
    }

    if(nextProps.createdBreedQuizFeaturesError !== this.props.createdBreedQuizFeaturesError){   
      const OTHER_Error_Message = "An error occured while creating the breed quiz features";
      const currentError = nextProps.createdBreedQuizFeaturesError;
      const error_message =  currentError &&  currentError.message ? currentError.message : OTHER_Error_Message;   
      this.setState({ loading : false, breedId : null, });  
      NotificationManager.error(error_message);
      $('#add_quiz_mapping').modal('hide');
      this.props.fetchBreedQuizFeatures();
    }
  
  }

render() {
  const {  
    breeds,breedId
  } = this.state;
    return (
    <div>
      <div
        className="modal fade show"
        id="add_quiz_mapping"
        tabIndex="-1"
        role="dialog"
        data-backdrop="static"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <form className="m-form">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                   New Quiz Mapping
                </h5>
                <button
                  type="button"
                  className="close"
                  onClick={this.closeModal}
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
            </div>            
            <div className="modal-body">
                <div className="row">
                  <div className="col-xl-12">
                    <div className="m-form__section m-form__section--first">
                        <div className="form-group m-form__group row">
                         <label className="col-xl-3 col-lg-3 col-form-label">
                             Breed                             
                          </label>
                          <div className="col-xl-9 col-lg-9">
                          <Select
                            options={breeds}
                            value={breedId}
                            name="breedId"
                            onChange={this.changeBreed}
                            placeholder="Select the breed"
                          />                    
                          </div>
                        </div>
                        <div className="form-group m-form__group row pb-0">
                          {  this.state.breedQuizFeatures.map((item,index) => (
                                  <div key={index} className="col-6">
                                  <div className="m-widget4">
                                    <div className="m-widget4__item">
                                      <div className="m-widget4__img m-widget4__img--icon">
                                        <input type="checkbox" checked={item.value} onChange={(e) => this.checkboxHandler(e,item,index)} />
                                      </div>
                                      <div className="m-widget4__info">
                                        <span className="m-widget4__text">
                                         {item.description}
                                        </span>
                                      </div>                         
                                    </div>                    								
                                  </div>  
                                </div>  
                          ))                      
                          }
                        </div>   
                                 
                    </div>
                   </div>
                </div>
            </div>   
            <div className="modal-footer">
            {this.state.loading == false ? (
                  <div>
                    <button
                      type="button"
                      className="btn btn-secondary m-btn--pill mx-2"
                      onClick={this.closeModal}
                    >
                      Close
                      </button>
                    <button
                      onClick={(e) =>{ this.submitBreedQuizFeatures(e); } }
                      type="submit"
                      className="btn btn-primary m-btn--pill"
                    >
                      Submit
                      </button>
                  </div>
                ) : (
                    <div className="center-row">
                      <Loader size={50} />
                    </div>
                  )}
            </div>     
        </form>
        </div>
        </div>
      </div>  
      
    </div>  
    )
}

}

const mapStateToProps = state => ({
    petShop: state.petShopReducer,
    breeds: state.addBreedTypeReducer.breedsByAnimal,
    breedQuizFeatures : state.quizReducer.breedQuizFeatures,
    availableBreed : state.quizReducer.availableBreed,
    createdBreedQuizFeatures : state.quizReducer.createdBreedQuizFeatures,
    createdBreedQuizFeaturesError : state.quizReducer.createdBreedQuizFeaturesError,
  });
  
  const mapDispatchToProps = dispatch => ({

    fetchBreedQuizFeatures: ()=>{
      dispatch(fetchBreedQuizFeatures());
    },
    createBreedQuizFeatures: (features)=> {
      dispatch(createBreedQuizFeatures(features));
    },
    getQuizFeaturesViaBreed: ()=>{
      dispatch(getQuizFeaturesViaBreed());
    },
    getAvailableQuizBreeds: ()=>{
      dispatch(getAvailableQuizBreeds());
    }

  });
  
  export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(AddQuizMapping)
  );